export const AUTH_SET_CURRENT_USER = 'AUTH_SET_CURRENT_USER';
export const AUTH_CHANGE_PASSWORD = 'AUTH_CHANGE_PASSWORD';